import React, { type FunctionComponent, type ReactNode, useState } from 'react'
import { MinusIcon, PlusIcon } from '../../icons'

type Props = {
  title: string | ReactNode
  ariaLabel?: string
  leadingElement?: ReactNode
  trailingElement?: ReactNode
  isOpen?: boolean
  children?: ReactNode
}

export const AccordionPanel: FunctionComponent<Props> = ({
  children,
  ariaLabel,
  title,
  leadingElement,
  trailingElement,
  isOpen
}) => {
  const [panelIsOpen, setPanelIsOpen] = useState<boolean>(isOpen || false)

  return (
    <section className="card mb-lg" aria-labelledby={`acc-${title}`}>
      <h2 id={`acc-${title}`}>
        <button
          aria-label={ariaLabel || `Toggle ${title} panel`}
          aria-expanded={panelIsOpen}
          className="text-left w-full p-lg"
          onClick={() => setPanelIsOpen(!panelIsOpen)}
        >
          <span className="flex space-x-md items-center justify-between">
            {leadingElement && <span>{leadingElement}</span>}

            {title}

            <span className="flex-1" />

            {trailingElement && trailingElement}

            {panelIsOpen ? (
              <MinusIcon title="hide" width="1.5rem" height="1.5rem" />
            ) : (
              <PlusIcon title="show" width="1.5rem" height="1.5rem" />
            )}
          </span>
        </button>
      </h2>

      {panelIsOpen ? <div className="pr-lg pb-lg pl-lg">{children}</div> : null}
    </section>
  )
}
